/* eslint no-use-before-define: 0 */

import Rx from "rxjs/Rx";
import { BaseTypeFilterComponent } from "./base-type-filter.component";

const frontPageTypeFilterSelectedSource = new Rx.Subject();
/**
 * {FrontPageTypeFilterComponent}
 */
export const frontPageTypeFilterSelected$ = frontPageTypeFilterSelectedSource.asObservable();

/*
 * - Produces frontPageTypeFilterSelected$ onClick
 */
export class FrontPageTypeFilterComponent extends BaseTypeFilterComponent {
    constructor(node, redirectionLinkBase) {
        super(node);
        this.initialize(redirectionLinkBase);
    }

    initialize(redirectionLinkBase) {
        if (!redirectionLinkBase) {
            return;
        }
        this.redirectionLink = redirectionLinkBase + (this.index >= 0 ? `?activeTypeFilterIndex=${this.index}` : "");
    }

    setActiveState() {
        const scope = this;
        super.setActiveState();
        redirectToRequestedPageOrSearch();

        function redirectToRequestedPageOrSearch() {
            if (!scope.redirectionLink) {
                return;
            }
            window.location.href = scope.redirectionLink;
        }
    }
}
